import { render, staticRenderFns } from "./User.vue?vue&type=template&id=4f8f7b6c"
import script from "./user.ts?vue&type=script&lang=js&external"
export * from "./user.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports